import React from "react";
import "./NotificationsMiddleStuff.css";

const NotificationsMiddleStuff = () => {
  return (
    <div className="notificationsmiddlestuff">
      <div className="notification">
        <div className="header">
          <div className="user">
            <div className="pfpboi">
              <img
                alt=""
                src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.fetchfind.com%2Fblog%2Fwp-content%2Fuploads%2F2017%2F08%2Fcat-2734999_1920-5-common-cat-sounds.jpg&f=1&nofb=1"
              />
            </div>
            <div className="userinfo">
              <h3>Idiot</h3>
              <small>@idiot</small>
            </div>
          </div>
          <span className="edit">
            <p>Follow</p>
          </span>
        </div>
        <div className="notificationtitle">
          <p>Idiot liked your post</p>
        </div>
      </div>
      <div className="notification">
        <div className="header">
          <div className="user">
            <div className="pfpboi">
              <img
                alt=""
                src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.fetchfind.com%2Fblog%2Fwp-content%2Fuploads%2F2017%2F08%2Fcat-2734999_1920-5-common-cat-sounds.jpg&f=1&nofb=1"
              />
            </div>
            <div className="userinfo">
              <h3>Idiot</h3>
              <small>@idiot</small>
            </div>
          </div>
          <span className="edit">
            <p>Follow</p>
          </span>
        </div>
        <div className="notificationtitle">
          <p>Idiot liked your post</p>
        </div>
      </div>
      <div className="notification">
        <div className="header">
          <div className="user">
            <div className="pfpboi">
              <img
                alt=""
                src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.fetchfind.com%2Fblog%2Fwp-content%2Fuploads%2F2017%2F08%2Fcat-2734999_1920-5-common-cat-sounds.jpg&f=1&nofb=1"
              />
            </div>
            <div className="userinfo">
              <h3>Idiot</h3>
              <small>@idiot</small>
            </div>
          </div>
          <span className="edit">
            <p>Follow</p>
          </span>
        </div>
        <div className="notificationtitle">
          <p>Idiot liked your post</p>
        </div>
      </div>
      <div className="notification">
        <div className="header">
          <div className="user">
            <div className="pfpboi">
              <img
                alt=""
                src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.fetchfind.com%2Fblog%2Fwp-content%2Fuploads%2F2017%2F08%2Fcat-2734999_1920-5-common-cat-sounds.jpg&f=1&nofb=1"
              />
            </div>
            <div className="userinfo">
              <h3>Idiot</h3>
              <small>@idiot</small>
            </div>
          </div>
          <span className="edit">
            <p>Follow</p>
          </span>
        </div>
        <div className="notificationtitle">
          <p>Idiot liked your post</p>
        </div>
      </div>
      <div className="notification">
        <div className="header">
          <div className="user">
            <div className="pfpboi">
              <img
                alt=""
                src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.fetchfind.com%2Fblog%2Fwp-content%2Fuploads%2F2017%2F08%2Fcat-2734999_1920-5-common-cat-sounds.jpg&f=1&nofb=1"
              />
            </div>
            <div className="userinfo">
              <h3>Idiot</h3>
              <small>@idiot</small>
            </div>
          </div>
          <span className="edit">
            <p>Follow</p>
          </span>
        </div>
        <div className="notificationtitle">
          <p>Idiot liked your post</p>
        </div>
      </div>
    </div>
  );
};

export default NotificationsMiddleStuff;
